// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1C7TU","actionsCol":"EnrolledClinics_actionsCol__15xDt"};